import actions from "./actions";

export default {
  namespaced: true,
  state: {
    audios: [],
    podcasts: [],
    podcastEpisodes: []
  },
  mutations: {
    resetAudios(state) {
      state.audios = [];
    },
    setAudios(state, audios) {
      state.audios = [...state.audios, ...audios];
    },
    setPodcasts(state, podcasts) {
      state.podcasts = podcasts;
    },
    setPodcastEpisodes(state, podcastEpisodes) {
      state.podcastEpisodes = podcastEpisodes;
    }
  },
  actions
};
